// COMPONENTS
import data_pagination from './data-pagination/data-pagination.js';
import fields_selector from './fields-selector/fields-selector.js';
import fields_filter from './fields-filter/fields-filter.js';
import picker from './picker/picker.js';
import select_with_input from './ko-select-with-input/ko-select-with-input.js';
import select_dropdown from './select-dropdown/select-dropdown.js';
import visible_columns from './visible-columns/visible-columns.js';
import ps_select from './ps-select/ps-select.js';
import ps_datetime_picker from './ps-datetime-picker/ps-datetime-picker.js';
import ps_upload_bar from './ps-upload-bar/ps-upload-bar.js';
import ko_tabs_dashboard from "./ko-tabs-dashboard/ko-tabs-dashboard.js";
import ko_page_title from "./ko-page-title/ko-page-title.js";
import ps_multiple_datepicker from "./ps-multiple-datepicker/ps-multiple-datepicker.js";
import ps_loader from './loader/ps-loader.js';
import ps_tags from './ps-tags/ps-tags.js';
import ps_lookup from './ps-lookup/ps-lookup.js';
import ps_table from './ps-table/ps-table.js';
import ps_record_filter from './ps-record-filter/ps-record-filter.js';
import ps_filter_entry from './ps-filter-entry/ps-filter-entry.js';
import ps_action_button from './ps-action-button/ps-action-button.js';
import ps_field_selector from './ps-field-selector/ps-field-selector.js';
import ps_formula from './formulas/ps-formula.js';
import ps_parameter from './formulas/ps-parameter.js';
import ps_number_input from './ps-number-input/ps-number-input.js';
import ko_numeric_range from './ko-numeric-range/ko-numeric-range.js';
import ko_date_range from './ko-date-range/ko-date-range.js';

export default [
	data_pagination,
	fields_selector,
	fields_filter,
	picker,
	select_with_input,
	select_dropdown,
	visible_columns,
	ps_select,
	ps_datetime_picker,
	ps_upload_bar,
	ko_tabs_dashboard,
	ko_page_title,
	ps_multiple_datepicker,
	ps_loader,
	ps_tags,
	ps_lookup,
	ps_table,
	ps_record_filter,
	ps_filter_entry,
	ps_action_button,
	ps_field_selector,
	ps_formula,
	ps_parameter,
	ps_number_input,
	ko_numeric_range,
	ko_date_range
];
